import(/* webpackMode: "eager" */ "/home/node/deploy/src/app/about/page.tsx");
